import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ShopPage from "../pages/shop/page";
import CategoryPage from "../pages/shop/category";
import ProductPage from "../pages/product/page";
import CartPage from "../pages/cart/page";
import CheckoutPage from "../pages/checkout/page";
import TechnologyPage from "../pages/technology/page";
import StoriesPage from "../pages/stories/page";
import StoryDetail from "../pages/stories/detail";
import OurStoryPage from "../pages/our-story/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/shop", element: <ShopPage /> },
  { path: "/shop/:slug", element: <CategoryPage /> },
  { path: "/product/:slug", element: <ProductPage /> },
  { path: "/cart", element: <CartPage /> },
  { path: "/checkout", element: <CheckoutPage /> },
  { path: "/technology", element: <TechnologyPage /> },
  { path: "/our-story", element: <OurStoryPage /> },
  { path: "/journal", element: <StoriesPage /> },
  { path: "/journal/:slug", element: <StoryDetail /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;